import { Component } from '@angular/core';

import { faEllipsisH, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'rupture',
    template: `
        <div class="rupture">
            <fa-icon [icon]="iconEllipsis"></fa-icon>
        </div>
    `,
    styles: [`
        .rupture {
            padding: .25rem;
            background-color: #f4f2f5;
            text-align: center;
        }
    `]
})
export class RuptureComponent {
    public iconEllipsis: IconDefinition = faEllipsisH;
}